export const isAdmin = window.location.origin.includes('admin.averpoint.com');
// export const isAdmin = true;
export const isStaging = window.location.origin.includes(
  'staging.averpoint.com',
);
